import { interval, from } from 'rxjs'
import { pluck, mergeMap, map, takeUntil, filter } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { SET_BOOKING_STATUS } from '../../../constants/actionTypes'
import { WATCH } from '../../../constants/roles'
import { status as gigStatus } from '@bt-react/constants'
import { actions } from '@bt-react/store'

export const pollInterval = 300000

const rescheduledFetchPoll$ = (actions$, state) => actions$.pipe(
  ofType(SET_BOOKING_STATUS),
  pluck('payload'),
  mergeMap(status => {

    if (status === gigStatus.RESCHEDULED) {

      return interval(pollInterval).pipe(
        takeUntil(actions$.pipe(
          ofType(SET_BOOKING_STATUS),
          pluck('payload'),
          map(status => status !== gigStatus.RESCHEDULED)
        )),
        map(() => {

          const [ channelId, webcastId ] = state.value.config.roomname.split('-')

          return actions.fetchPublicWebcastData(channelId, webcastId)

        })
      )

    }
    else {

      return from([])

    }

  })

)

export const rescheduledFetch$ = (actions$, state) => actions$.pipe(
  ofType(SET_BOOKING_STATUS),
  pluck('payload'),
  filter(status =>
    status === gigStatus.RESCHEDULED &&
    state.value.config.role !== WATCH
  ),
  map(() => {

    const [ channelId, webcastId ] = state.value.config.roomname.split('-')

    return actions.fetchPublicWebcastData(channelId, webcastId)

  })

)

export default rescheduledFetchPoll$
